var React = require('react');
var labels = require('MemberJoinLabels');
var moment = require('moment');
var { $datePicker, $input } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');

class PaymentInformation extends React.Component {
    constructor(props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {

    }

    handleInputChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
    }

    render() {
        return <div className={"payment-information-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step6.paymentInformation}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            <div className={"field-wrap"}>
                                <label>{labels.step6.ccNumber}</label>
                                <$input name="ccNumber" value={this.props.stepState.ccNumber} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                            </div>
                            <div className={"field-wrap"}>
                                <label>{labels.step6.ccName}</label>
                                <$input name="ccName" value={this.props.stepState.ccName} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                            </div>
                        </div>
                        <div className={"col-md-12 cc-expire-info"}>
                            <div className={"row"}>
                                <div className={"col-md-3"}>
                                    <div className={"field-wrap"}>
                                        <label>{labels.step6.ccExpireMonth}</label>
                                        <$input name="ccExpirationMonth" value={this.props.stepState.ccExpirationMonth} onChange={this.handleInputChange} validations={[validationFunctions.required]} maxLength="2" />
                                    </div>
                                </div>
                                <div className={"col-md-3"}>
                                    <div className={"field-wrap"}>
                                        <label>{labels.step6.ccExpireYear}</label>
                                        <$input name="ccExpirationYear" value={this.props.stepState.ccExpirationYear} onChange={this.handleInputChange} validations={[validationFunctions.required, validationFunctions.expirationYear]} maxLength="4" />
                                    </div>
                                </div>
                                <div className={"col-md-3"}>
                                    <div className={"field-wrap"}>
                                        <label>{labels.step6.ccSecurityCode}</label>
                                        <$input name="ccSecurityCode" value={this.props.stepState.ccSecurityCode} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

module.exports = PaymentInformation;